<script lang="ts">
  import { generateId } from "#lib/internal/helpers"
  import { cn } from "#lib/utils"
  import type { VariantProps } from "class-variance-authority"
  import type { Snippet } from "svelte"
  import type { buttonVariants } from "../button"
  import Button from "../button/Button.svelte"
  import { getDialogRootContext } from "./DialogRoot.svelte"

  type Props = {
    variant?: VariantProps<typeof buttonVariants>["variant"]
    class?: string | undefined | null
    children?: Snippet
    [key: string]: unknown
  }

  let {
    variant = "secondary",
    class: cssClass = "",
    children,
    ...restProps
  }: Props = $props()

  const rootCtx = getDialogRootContext()

  const id = generateId()
</script>

<Button
  {id}
  {variant}
  aria-haspopup="dialog"
  aria-expanded={$rootCtx.open}
  class={cn(cssClass)}
  onclick={() => {
    $rootCtx.open = true
    $rootCtx.triggeredId = $rootCtx.open ? id : null
  }}
  {...restProps}
>
  {@render children?.()}
</Button>
